module.exports = __webpack_public_path__ + "static/media/loader3.9fe4030b.gif";